import { Component, OnInit } from '@angular/core';
import { ParametrosHistoricoRecepcaoTransmissao, RetornoHistoricoRecepcaoTransmissao } from '@modules/clientes/services/clientes.interface';
import { ClientesService } from '@modules/clientes/services/clientes.service';
import { VisitasService } from '@modules/visitas/services/visitas.service';
import { Vendedor } from '@shared/models';
import { ConsultRequest } from '@shared/utils/consult-request';
import { FiltersOfConsult } from '@shared/utils/filters-of-consult';
import { Filters } from './historico-recepcao-transmissao.models';


@Component({
  selector: 'app-historico-recepcao-transmissao',
  templateUrl: './historico-recepcao-transmissao.component.html',
  styleUrls: ['./historico-recepcao-transmissao.component.css']
})
export class HistoricoRecepcaoTransmissaoComponent implements OnInit {

  vendedor : Vendedor;
  vendedorLoading : boolean = false;
  vetorSetor: any;
  setorFzs: string;

  filtersOfConsult = new FiltersOfConsult<Filters>({
    setor: null,
    vendedor: null,
    status: -1,
    dtSelecionada: ""
  });
  
  lsVendedores: Vendedor[] = [];

  constructor(private clientService: ClientesService,
              private visitService: VisitasService,) { }

  ngOnInit() {
  }

  constultaRequest = new ConsultRequest<RetornoHistoricoRecepcaoTransmissao[]>()

  getVendedores(){ 
    this.vendedorLoading = true;
    this.visitService.getVendedoresPorSetor(this.vetorSetor.codigo).subscribe(
      data => {
        this.lsVendedores = data;

        if (data.length == 1) {
          this.filtersOfConsult.filters.vendedor = data[0];
        }
        else {
          this.filtersOfConsult.filters.vendedor = null;
        }

        this.vendedorLoading = false;
    },
      error => console.log(error)
    );
  }

  getIdSetorComc(){
    if(this.vetorSetor){
      //this.filtersOfConsult.filters.CdFzs = this.vetorSetor.codigo;
      this.setorFzs = this.vetorSetor.codigo;
    }
    this.clientService.getIdSetor(this.setorFzs)
      .subscribe(
        data => {
          const idSetor: any = data;
          if(idSetor != 0){
            this.filtersOfConsult.filters.setor = idSetor;
            //this.getStates(idSetor);
            this.getVendedores();
          }else{
            toastr.error('Setor não encontrado')
          }

        },
        error => {
          console.log(error)
        }
      )
  }

  onConsultar(){
    this.constultaRequest.get(
      this.clientService.getHistoricoRecepcaoTransmissao(this.filtersOfConsult.filters.setor, this.filtersOfConsult.filters.vendedor.idSetor.toString(), this.filtersOfConsult.filters.dtSelecionada, this.filtersOfConsult.filters.status)
    )
  }

}
